<template>
  <div>
    <br />
    <div class="row px-4 mx-4 col-sm-10 col-lg-8 mx-auto">
      <div class="col mx-4">
        <b-form @submit="onSubmit">
          <b-form-input class="hidden" id="hpot" v-model="form.hpot"></b-form-input>

          <h2 class="text-left text-black">Benvenuto</h2>
          <b-form-input
            v-model="form.email"
            type="email"
            id="email"
            required
            placeholder="La tua email"
            class="my-4 p-3 border-secondary big__input"
          ></b-form-input>
          <b-form-input
            v-model="form.password"
            type="password"
            id="password"
            required
            placeholder="La tua password"
            class="my-4 big__input"
          ></b-form-input>

          <div v-show="error">
            <p class="text-danger">Credenziali non valide</p>
          </div>
          <div>
            <p class="mb-0">Password dimenticata?</p>
            <p
              class="text-secondary point font-weight-bold"
              @click="showRecoverModal = !showRecoverModal"
            >Configura nuova password.</p>
          </div>
          <div class="row mx-auto text center">
            <b-button type="submit" variant="primary" class="font-weight-bold ml-auto mr-2">Accedi</b-button>
            <b-button
              type="button"
              variant="secondary"
              class="font-weight-bold ml-2 mr-auto"
              @click="toRegister"
            >Registrati</b-button>
          </div>
        </b-form>
      </div>
      <div class="col-5 mx-auto align-content-center px-0">
        <h2 class="text-left text-white">Benvenuto</h2>
        <div class="image__div">
          <DottorLogo />
        </div>
      </div>
    </div>
    <b-modal v-model="showRecoverModal" variant="primary" size="lg" title="Recupera Password">
      <b-form-input
        v-model="reset.email"
        type="email"
        id="email_recover"
        required
        placeholder="Inserisci la tua email"
        class="my-4 p-3 border-secondary big__input"
      ></b-form-input>
      <p v-if="resetSent">Mail inviata! Controlla la tua casella email.</p>
      <b-button
        v-if="!resetSent"
        type="button"
        variant="secondary"
        class="font-weight-bold ml-2 mr-auto"
        @click="resetPassword"
        :disabled="reset.email ? false : true"
      >Invia Mail</b-button>
      <b-button
        v-else
        type="button"
        variant="primary"
        class="font-weight-bold ml-2 mr-auto"
        @click="showRecoverModal = !showRecoverModal"
      >Ok</b-button>
    </b-modal>
  </div>
</template>
<script>
// @ is an alias to /src

import DottorLogo from "../../public/svg/dottor.svg";
export default {
  name: "login",
  components: {
    DottorLogo
  },
  data() {
    return {
      form: {
        email: null,
        password: null,
        hpot: null
      },
      error: false,
      showRecoverModal: false,
      reset: {
        email: null
      },
      resetSent: false
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.validate() && this.logUserIn();
    },
    validate() {
      if (this.form.hpot === null) {
        return true;
      }
      return false;
    },
    logUserIn() {
      this.$axios
        .post("/login", this.form)
        .then(res => {
          // console.log(res.data.data);
          // this.$store.dispatch("login", res.data.data).then(() => {
          // this.$emit("logged-in");
          this.$router.go();
          // });
        })
        .catch(err => {
          console.log(err);
          if (err.response.status === 422) {
            this.error = true;
          }
        });
    },
    toRegister() {
      this.$emit("update-view");
    },
    resetPassword() {
      this.$axios
        .post("/password/reset", this.reset)
        .then(res => {
          console.log(res.data.data);
          this.resetSent = true;
        })
        .catch(err => {
          console.log(err);
          if (err.response.status === 422) {
            this.error = true;
          }
        });
    }
  },
  created() {}
};
</script>
<style scoped>
span:hover {
  text-decoration: underline;
}
.image__div {
  /* width: "454.81";
  height: "468.97"; */
}
.a {
  fill: #ffccbc;
}
.b {
  fill: #ffab91;
}
.c {
  fill: #fff;
}
.d {
  fill: #eceff1;
}
.e {
  fill: #d1c4e9;
}
.f {
  fill: #9575cd;
}
.g {
  fill: #37474f;
}
.h {
  fill: #01579b;
}
.i {
  fill: #ff8a65;
}
.j {
  fill: #263238;
}
.k {
  fill: #4f2121;
}
.l {
  fill: #792121;
}
</style>
